// import React from 'react'

// const AttendanceSheet = () => {
//   return (
//     <div>AttendanceSheet</div>
//   )
// }

// export default AttendanceSheet



// src/components/LeaveRequestsTable.js
// src/components/AttendanceSheet.js
// src/components/AttendanceSheet.js
import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
// import './AttendanceSheet.css';
import { FaEdit, FaTrash, FaFilter, FaFileExport, FaPlus } from 'react-icons/fa';

const AttendanceSheet = () => {
  // State for leave requests
  const [leaveRequests, setLeaveRequests] = useState([
    {
      employee: 'Dr. John D.',
      employeeId: 'E123',
      department: 'Emergency D...',
      leaveType: 'Sick Leave',
      leaveFrom: '11/01/2024',
      leaveTo: '11/05/2024',
      numberOfDays: 5,
      duration: 'Full-day',
      status: 'Approved',
      reason: 'Flu symptoms...',
      requestedOn: '10/30/2024',
      approvedBy: 'Dr. Jane Smith',
      approveDate: '10/31/2024',
    },
    {
      employee: 'Nurse Sar...',
      employeeId: 'E124',
      department: 'Cardiology',
      leaveType: 'Maternity Le...',
      leaveFrom: '12/01/2024',
      leaveTo: '01/01/2025',
      numberOfDays: 31,
      duration: 'Full-day',
      status: 'Pending',
      reason: 'Pregnancy a...',
      requestedOn: '10/15/2024',
      approvedBy: '',
      approveDate: '',
    },
    {
      employee: 'Dr. Edna G.',
      employeeId: 'E125',
      department: 'Pediatrics',
      leaveType: 'Medical Leave',
      leaveFrom: '11/01/2024',
      leaveTo: '11/03/2024',
      numberOfDays: 2,
      duration: 'Half-day',
      status: 'Rejected',
      reason: 'Surgery reco...',
      requestedOn: '10/18/2024',
      approvedBy: '',
      approveDate: '',
    },
    {
      employee: 'Dr. Shelia ...',
      employeeId: 'E126',
      department: 'IT Support',
      leaveType: 'Sick Leave',
      leaveFrom: '11/05/2024',
      leaveTo: '11/07/2024',
      numberOfDays: 3,
      duration: 'Full-day',
      status: 'Approved',
      reason: 'Flu symptoms...',
      requestedOn: '11/02/2024',
      approvedBy: 'Dr. Tom John...',
      approveDate: '11/03/2024',
    },
    {
      employee: 'Nurse Bar...',
      employeeId: 'E127',
      department: 'ICU',
      leaveType: 'Casual Leave',
      leaveFrom: '11/15/2024',
      leaveTo: '11/17/2024',
      numberOfDays: 2,
      duration: 'Full-day',
      status: 'Approved',
      reason: 'Personal err...',
      requestedOn: '10/30/2024',
      approvedBy: 'Nurse Lisa G...',
      approveDate: '10/31/2024',
    },
    {
      employee: 'Dr. Sarah ...',
      employeeId: 'E128',
      department: 'Surgery',
      leaveType: 'Medical Leave',
      leaveFrom: '11/05/2024',
      leaveTo: '11/08/2024',
      numberOfDays: 3,
      duration: 'Half-day',
      status: 'Pending',
      reason: 'Recovering f...',
      requestedOn: '11/01/2024',
      approvedBy: '',
      approveDate: '',
    },
    {
      employee: 'Nurse Mar...',
      employeeId: 'E129',
      department: 'Neurology',
      leaveType: 'Casual Leave',
      leaveFrom: '11/10/2024',
      leaveTo: '11/12/2024',
      numberOfDays: 2,
      duration: 'Half-day',
      status: 'Rejected',
      reason: 'Annual chec...',
      requestedOn: '11/01/2024',
      approvedBy: '',
      approveDate: '',
    },
    {
      employee: 'Dr. Kara T.',
      employeeId: 'E130',
      department: 'Emergency D...',
      leaveType: 'Casual Leave',
      leaveFrom: '11/15/2024',
      leaveTo: '11/17/2024',
      numberOfDays: 3,
      duration: 'Full-day',
      status: 'Approved',
      reason: 'Family emer...',
      requestedOn: '11/01/2024',
      approvedBy: 'Dr. Anne White',
      approveDate: '11/02/2024',
    },
    {
      employee: 'Dr. Josep...',
      employeeId: 'E131',
      department: 'Orthopedics',
      leaveType: 'Medical Leave',
      leaveFrom: '11/10/2024',
      leaveTo: '11/12/2024',
      numberOfDays: 3,
      duration: 'Half-day',
      status: 'Approved',
      reason: 'Post-operati...',
      requestedOn: '11/02/2024',
      approvedBy: 'Dr. Mark Bro...',
      approveDate: '11/02/2024',
    },
    {
      employee: 'Nurse Ric...',
      employeeId: 'E132',
      department: 'Pediatrics',
      leaveType: 'Maternity Le...',
      leaveFrom: '12/01/2024',
      leaveTo: '01/01/2025',
      numberOfDays: 31,
      duration: 'Full-day',
      status: 'Rejected',
      reason: 'Pregnancy a...',
      requestedOn: '11/07/2024',
      approvedBy: '',
      approveDate: '',
    },
  ]);

  // State for modal visibility and form data
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [formData, setFormData] = useState({
    employee: '',
    employeeId: '',
    department: '',
    leaveType: '',
    leaveFrom: '',
    leaveTo: '',
    numberOfDays: '',
    duration: '',
    reason: '',
    requestedOn: '',
    approvedBy: '',
    approveDate: '',
  });

  // Debug state changes
  useEffect(() => {
    console.log('isModalOpen state:', isModalOpen);
  }, [isModalOpen]);

  // Function to download table data as Excel
  const downloadExcel = () => {
    const excelData = leaveRequests.map((request) => ({
      Employee: request.employee,
      'Employee ID': request.employeeId,
      Department: request.department,
      'Leave Type': request.leaveType,
      'Leave From': request.leaveFrom,
      'Leave To': request.leaveTo,
      'Number of Days': request.numberOfDays,
      Duration: request.duration,
      Status: request.status,
      Reason: request.reason,
      'Requested On': request.requestedOn,
      'Approved By': request.approvedBy,
      'Approve Date': request.approveDate,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Leave Requests');
    XLSX.writeFile(workbook, 'Leave_Requests.xlsx');
  };

  // Open modal for adding a new request
  const openAddModal = () => {
    console.log('Opening Add Modal');
    setIsModalOpen(true);
    setIsEditMode(false);
    setFormData({
      employee: '',
      employeeId: '',
      department: '',
      leaveType: '',
      leaveFrom: '',
      leaveTo: '',
      numberOfDays: '',
      duration: '',
      reason: '',
      requestedOn: '',
      approvedBy: '',
      approveDate: '',
    });
  };

  // Open modal for editing an existing request
  const openEditModal = (index) => {
    console.log('Opening Edit Modal for index:', index);
    setIsModalOpen(true);
    setIsEditMode(true);
    setEditIndex(index);
    setFormData(leaveRequests[index]);
  };

  // Close modal
  const closeModal = () => {
    console.log('Closing Modal');
    setIsModalOpen(false);
    setIsEditMode(false);
    setEditIndex(null);
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEditMode) {
      const updatedRequests = [...leaveRequests];
      updatedRequests[editIndex] = { ...formData, status: updatedRequests[editIndex].status };
      setLeaveRequests(updatedRequests);
    } else {
      setLeaveRequests([...leaveRequests, { ...formData, status: 'Pending' }]);
    }
    closeModal();
  };

  // Handle delete request
  const handleDelete = (index) => {
    const updatedRequests = leaveRequests.filter((_, i) => i !== index);
    setLeaveRequests(updatedRequests);
  };

  return (
    <div className="leave-requests-container">
      <div className="breadcrumb">
        <span>HR</span> &gt; <span>Leave Requests</span>
      </div>
      <div className="header">
        <h4>Leave Requests</h4>
        <div className="header-actions">
          <button className="add-btn" onClick={openAddModal}>
            <FaPlus /> Add New Request
          </button>
          <input type="text" placeholder="Search Employee" className="search-bar" />
          <button className="icon-btn">
            <FaFilter />
          </button>
          <button className="icon-btn" onClick={downloadExcel} title="Download as Excel">
            <FaFileExport />
          </button>
        </div>
      </div>

      {/* Debug Modal Rendering */}
      <div>
        {console.log('Rendering modal, isModalOpen:', isModalOpen)}
        {isModalOpen ? (
          <div className="modal-overlay">
            <div className="modal">
              <h3>{isEditMode ? 'Edit Leave Request' : 'Add Leave Request'}</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Employee</label>
                  <input
                    type="text"
                    name="employee"
                    value={formData.employee}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Employee ID</label>
                  <input
                    type="text"
                    name="employeeId"
                    value={formData.employeeId}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Department</label>
                  <input
                    type="text"
                    name="department"
                    value={formData.department}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Leave Type</label>
                  <select
                    name="leaveType"
                    value={formData.leaveType}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Leave Type</option>
                    <option value="Sick Leave">Sick Leave</option>
                    <option value="Maternity Leave">Maternity Leave</option>
                    <option value="Medical Leave">Medical Leave</option>
                    <option value="Casual Leave">Casual Leave</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Leave From</label>
                  <input
                    type="date"
                    name="leaveFrom"
                    value={formData.leaveFrom}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Leave To</label>
                  <input
                    type="date"
                    name="leaveTo"
                    value={formData.leaveTo}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Number of Days</label>
                  <input
                    type="number"
                    name="numberOfDays"
                    value={formData.numberOfDays}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Duration</label>
                  <select
                    name="duration"
                    value={formData.duration}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Duration</option>
                    <option value="Full-day">Full-day</option>
                    <option value="Half-day">Half-day</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Reason</label>
                  <textarea
                    name="reason"
                    value={formData.reason}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Requested On</label>
                  <input
                    type="date"
                    name="requestedOn"
                    value={formData.requestedOn}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Approved By</label>
                  <input
                    type="text"
                    name="approvedBy"
                    value={formData.approvedBy}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Approve Date</label>
                  <input
                    type="date"
                    name="approveDate"
                    value={formData.approveDate}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-actions">
                  <button type="button" onClick={closeModal} className="cancel-btn">
                    Cancel
                  </button>
                  <button type="submit" className="save-btn">
                    {isEditMode ? 'Update' : 'Save'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        ) : (
          <div style={{ display: 'none' }}></div> // Placeholder when modal is not open
        )}
      </div>

      {/* Table */}
      <table className="leave-table">
        <thead>
          <tr>
            <th>
              <input type="checkbox" />
            </th>
            <th>Employee</th>
            <th>Employee ID</th>
            <th>Department</th>
            <th>Leave Type</th>
            <th>Leave From</th>
            <th>Leave To</th>
            <th>Number of Days</th>
            <th>Duration</th>
            <th>Status</th>
            <th>Reason</th>
            <th>Requested On</th>
            <th>Approved By</th>
            <th>Approve Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {leaveRequests.map((request, index) => (
            <tr key={index}>
              <td>
                <input type="checkbox" />
              </td>
              <td>
                <div className="employee-cell">
                  <div className="avatar"></div>
                  {request.employee}
                </div>
              </td>
              <td>{request.employeeId}</td>
              <td>{request.department}</td>
              <td>{request.leaveType}</td>
              <td>{request.leaveFrom}</td>
              <td>{request.leaveTo}</td>
              <td>{request.numberOfDays}</td>
              <td>{request.duration}</td>
              <td>
                <span
                  className={`status ${
                    request.status === 'Approved'
                      ? 'approved'
                      : request.status === 'Pending'
                      ? 'pending'
                      : 'rejected'
                  }`}
                >
                  {request.status}
                </span>
              </td>
              <td>{request.reason}</td>
              <td>{request.requestedOn}</td>
              <td>{request.approvedBy}</td>
              <td>{request.approveDate}</td>
              <td>
                <button className="action-btn edit" onClick={() => openEditModal(index)}>
                  <FaEdit />
                </button>
                <button className="action-btn delete" onClick={() => handleDelete(index)}>
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pagination">
        <span>Items per page:</span>
        <select>
          <option>10</option>
          <option>20</option>
          <option>50</option>
        </select>
        <span>1 - 10 of 10</span>
        <button>&lt;</button>
        <button>&gt;</button>
      </div>
    </div>
  );
};

export default AttendanceSheet;